import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {

    static targets = [
        "input",
        "progressBar",
        "submitButton",
        "uploadedPath",
        "log",
        "uploadId",
        "closeButton",
        "dropzone",
        "form",
        "filterButton"
    ]

    connect() {

        console.log("connect file upload controller")

        this.lines = []
        this.progressLines = {}

        this.subscribe()

        this.dropzoneTarget.addEventListener("dragover", (e) => {
            e.preventDefault()
        })

        this.dropzoneTarget.addEventListener("drop", (e) => {

            e.preventDefault()

            const file = e.dataTransfer.files[0]

            if (!file) return

            this.inputTarget.files = e.dataTransfer.files

            this.uploadFile()
        })

        this.modal = this.element.closest(".modal")

        if (this.modal) {

            this.modal.addEventListener(
                "hidden.bs.modal",
                () => {
                    console.log("disconnect file upload controller")
                    this.unsubscribe()
                }
            )
        }
    }

    disconnect() {

        console.log("disconnect file upload controller")

        this.unsubscribe()
    }

    subscribe() {

        this.channel = consumer.subscriptions.create(
            {
                channel: "LongOperationsChannel",
                upload_id: this.uploadIdTarget.value
            },
            {
                received: (data) => {

                    switch(data.type) {

                        case "log":

                            this.appendLog(data.message)

                            break

                        case "progress":

                            this.updateProgress(
                                data.key,
                                data.message,
                                data.current,
                                data.total
                            )

                            break

                        case "finished":

                            this.finishProgress()

                            this.appendLog(data.message)

                            this.submitButtonTarget.disabled = true
                            this.closeButtonTarget.disabled = false

                            if (data.fromdt && data.todt) {

                                this.fromdt = data.fromdt
                                this.todt = data.todt

                                this.filterButtonTarget.disabled = false
                            }

                            break
                    }
                }
            }
        )
    }

    unsubscribe() {

        if (this.channel) {

            consumer.subscriptions.remove(this.channel)

            this.channel = null
        }
    }

    renderLog() {

        const progress =
            Object.values(this.progressLines)

        this.logTarget.value =
            [...this.lines, ...progress].join("\n")

        this.logTarget.scrollTop =
            this.logTarget.scrollHeight
    }

    appendLog(message) {

        this.lines.push(message)

        this.renderLog()
    }

    updateProgress(key, message, current, total) {

        const width = 30

        const filled =
            Math.round((current / total) * width)

        const empty = width - filled

        const bar =
            "█".repeat(filled) +
            "░".repeat(empty)

        this.progressLines[key] =
            `${message} [${bar}] ${current}/${total}`

        this.renderLog()
    }

    finishProgress() {

        Object.values(this.progressLines).forEach(line => {

            const exists =
                this.lines.includes(line)

            if (!exists) {
                this.lines.push(line)
            }
        })

        this.progressLines = {}

        this.renderLog()
    }

    uploadFile() {

        const file = this.inputTarget.files[0]

        if (!file) return

        this.lines = []
        this.progressLines = {}

        this.progressBarTarget.style.width = "0%"
        this.progressBarTarget.innerText = "0%"

        this.submitButtonTarget.disabled = true
        this.closeButtonTarget.disabled = true
        this.filterButtonTarget.disabled = true

        this.uploadedPathTarget.value = ""

        this.logTarget.value = ""

        this.appendLog(`Выбран файл: ${file.name}`)

        const formData = new FormData()

        formData.append("file", file)

        const xhr = new XMLHttpRequest()

        xhr.open("POST", "/upload_file")

        const token =
            document.querySelector(
                'meta[name="csrf-token"]'
            ).content

        xhr.setRequestHeader(
            "X-CSRF-Token",
            token
        )

        xhr.upload.addEventListener("progress", (e) => {

            if (!e.lengthComputable) return

            const percent =
                Math.round(
                    (e.loaded / e.total) * 100
                )

            this.progressBarTarget.style.width =
                `${percent}%`

            this.progressBarTarget.innerText =
                `${percent}%`
        })

        xhr.onload = () => {

            if (xhr.status !== 200) {

                this.appendLog("Ошибка загрузки файла")

                return
            }

            const response =
                JSON.parse(xhr.responseText)

            this.uploadedPathTarget.value =
                response.path

            this.submitButtonTarget.disabled = false

            this.appendLog("Файл загружен")
        }

        xhr.send(formData)
    }

    async submit(e) {

        e.preventDefault()

        this.submitButtonTarget.disabled = true

        this.appendLog("Запуск обработки...")

        const formData =
            new FormData(this.formTarget)

        const response = await fetch(
            this.formTarget.action,
            {
                method: "POST",
                body: formData,
                headers: {
                    "X-CSRF-Token":
                    document.querySelector(
                        'meta[name="csrf-token"]'
                    ).content,
                    "Accept": "application/json"
                }
            }
        )

        if (!response.ok) {
            this.appendLog("Ошибка запуска обработки")
        }
    }

    filterLastLoaded() {

        const url =
            new URL(window.location.href)

        url.searchParams.set(
            "updated_at.fromdt",
            this.fromdt
        )

        url.searchParams.set(
            "updated_at.todt",
            this.todt
        )

        window.location.href =
            url.toString()
    }
}